import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hovered"];
import useHovered from 'UIComponents/hooks/useHovered';
import UITextInput from 'UIComponents/input/UITextInput';
import emptyFunction from 'react-utils/emptyFunction';
import FormControl from '../../../v2/components/FormControl';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { PositionedButtonContainer } from './PositionedButtonContainer';
import { HiddenMaskedDisplay } from './HiddenMaskedDisplay';
import styled from 'styled-components';
import { getDataAttributes } from '../../../utils/getDataAttributes';
import { HIGHLY_SENSITIVE_MASKED_DISPLAY } from '../../../dataSensitivity/highlySensitiveMaskedDisplay';
import { ShowHighlySensitiveValueButton } from '../../../dataSensitivity/ShowHighlySensitiveValueButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RelativeUIFlex = styled(UIFlex).withConfig({
  displayName: "PropertyInputHighlySensitiveNonFloating__RelativeUIFlex",
  componentId: "sc-1lqd0b2-0"
})(["position:relative;"]);
export const PropertyInputHighlySensitiveNonFloating = props => {
  const {
    className,
    use,
    formControlProps = {},
    inputProps = {}
  } = props;
  const _useHovered = useHovered({}),
    {
      hovered
    } = _useHovered,
    hoveredProps = _objectWithoutPropertiesLoose(_useHovered, _excluded);
  return /*#__PURE__*/_jsxs(RelativeUIFlex, Object.assign({}, hoveredProps, {
    align: "center",
    direction: "row",
    children: [/*#__PURE__*/_jsx(UIBox, {
      grow: 1,
      children: /*#__PURE__*/_jsx(FormControl, Object.assign({}, formControlProps, {
        formControlUse: use,
        children: /*#__PURE__*/_jsx(UITextInput, Object.assign({
          className: className
        }, getDataAttributes(inputProps), {
          value: HIGHLY_SENSITIVE_MASKED_DISPLAY,
          onChange: emptyFunction
        }))
      }))
    }), /*#__PURE__*/_jsxs(PositionedButtonContainer, {
      $formControlUse: use,
      children: [/*#__PURE__*/_jsx(HiddenMaskedDisplay, {
        $formControlUse: use,
        className: "m-right-2",
        children: HIGHLY_SENSITIVE_MASKED_DISPLAY
      }), /*#__PURE__*/_jsx(ShowHighlySensitiveValueButton, {
        isVisible: hovered
      })]
    })]
  }));
};